import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_71: FaireProductEntity = {
  token: "starter_collection_71",
  type: "product",
  name: "Denim Tea Towels",
  brandName: "Atelier Saucier",
  imageUrl:
    '"https://cdn.faire.com/fastly/01c815815eaea0d5c42f130194f58bc4e7b20b2beea9ea96bd99b670cc2f369c.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=1005',
  priceDollars: 36,
  msrpDollars: 72,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
